// @dynamic-i18n-keys
//   actionbar.regularView
//   actionbar.regularView.disabled
//   actionbar.expandView
//   actionbar.expandView.disabled
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import ExpandIcon from '@wix/da-ds/pkg/Icons/Expand';
import ShrinkIcon from '@wix/da-ds/pkg/Icons/Shrink';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { useDeviationViewContext } from '../../../Context';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarButton from '../../_partials/items/ActionBarButton';

export interface Props {
  deviation: PapiDeviation;
  canFullscreen: boolean;
  onClick: (deviation: PapiDeviation) => void;
}

export const ExpandButton: React.FC<React.PropsWithChildren<Props>> = ({
  canFullscreen,
  deviation,
  onClick,
}) => {
  const { t } = useTranslation();
  const { isFullscreen } = useDeviationViewContext();
  const tooltip = t(
    `actionbar.${isFullscreen ? 'regular' : 'expand'}View${canFullscreen ? '' : '.disabled'}`
  );

  return (
    <ActionBarItemWrapper tooltip={tooltip}>
      <ActionBarButton
        onClick={() => onClick(deviation)}
        disabled={!canFullscreen}
        aria-label={tooltip}
      >
        <ActionBarIcon icon={isFullscreen ? ShrinkIcon : ExpandIcon} />
      </ActionBarButton>
    </ActionBarItemWrapper>
  );
};
ExpandButton.displayName = 'ExpandButton';

export default ExpandButton;
